export default __webpack_public_path__ + "images/467b5814d6a3ff258e1c8930146a171d.svg";